import { Panel } from '@/components/Panel';
import { useAlerts } from '@/hooks/useAlerts';
import { StatusBadge, EmptyState, Spinner } from '@00start/ui';

function severityColorKey(severity: string): string {
  const s = severity?.toLowerCase();
  if (s === 'critical' || s === 'high') return 'critical';
  if (s === 'medium') return 'high';
  return 'low';
}

export function AlertFeed() {
  const { alerts, loading } = useAlerts();

  return (
    <Panel title="Alerts" mobilePriority={4}>
      {loading ? (
        <div className="flex justify-center py-4"><Spinner size="sm" /></div>
      ) : alerts.length === 0 ? (
        <EmptyState title="No alerts" description="No alerts in the last 24 hours" />
      ) : (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {alerts.slice(0, 20).map((a, i) => (
            <div key={i} className="flex items-start gap-2 text-[11px]">
              <StatusBadge
                label={a.severity || 'unknown'}
                colorKey={severityColorKey(a.severity)}
                variant="severity"
                className="flex-shrink-0 text-[10px]"
              />
              <div className="min-w-0">
                <p className="text-slate-300 truncate">{a.message}</p>
                <p className="text-slate-600 text-[10px]">
                  {new Date(a.timestamp).toLocaleTimeString()}
                  {a.service ? ` — ${a.service}` : ''}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
